'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('../css/Switcher.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
Pflichtproperties:


optional:

*/

var Switcher = function (_Component) {
  _inherits(Switcher, _Component);

  function Switcher(props) {
    _classCallCheck(this, Switcher);

    var _this = _possibleConstructorReturn(this, (Switcher.__proto__ || Object.getPrototypeOf(Switcher)).call(this, props));

    _this.state = {};
    _this.state.on = _this.props.On;
    return _this;
  }

  _createClass(Switcher, [{
    key: 'componentDidMount',
    value: function componentDidMount() {

      if (this.state.on) {
        (0, _jquery2.default)("#" + this.props.Id).prop("checked", "checked");
      }
    }
  }, {
    key: 'GetValue',
    value: function GetValue() {
      return this.state.on;
    }
  }, {
    key: 'ChangeValue',
    value: function ChangeValue() {
      this.setState({ on: !this.state.on });
    }
  }, {
    key: 'Update',
    value: function Update(me) {
      var _this2 = this;

      if (me) {
        me.setState({ on: !me.state.on }, function () {
          if (_this2.props.Id) {
            if (_this2.props.referenc) {
              if (typeof _this2.props.referenc.Switch === "function") {
                if (_this2.props.referenc.Switch() !== undefined || _this2.props.referenc.Switch(_this2.props.Id) !== undefined) {
                  _this2.props.referenc.Switch(_this2.props.Id);
                }
              }
            }
          }
          if (_this2.props.OnClick !== undefined) {
            _this2.props.OnClick();
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var label = "";

      if (this.props.Label) {
        label = _react2.default.createElement(
          'div',
          { style: { float: 'left', lineHeight: '60px', marginRight: '10px' } },
          this.props.Label
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        label,
        _react2.default.createElement(
          'div',
          { style: { float: 'left' } },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('input', {
              type: 'checkbox',
              id: this.props.Id,
              style: { opacity: '0', float: 'left' },
              onChange: function onChange() {
                _this3.Update(_this3);
              }
            }),
            _react2.default.createElement(
              'label',
              { htmlFor: this.props.Id },
              _react2.default.createElement(
                'div',
                { className: 'slider-wrapper' },
                _react2.default.createElement(
                  'div',
                  { className: 'slider-options' },
                  _react2.default.createElement('div', { className: 'slider-option slider-option-no' }),
                  _react2.default.createElement('div', { className: 'slider-option-selector' }),
                  _react2.default.createElement('div', { className: 'slider-option slider-option-yes' })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Switcher;
}(_react.Component);

exports.default = Switcher;